import React from "react";
import "../styles/Contact.css";
import { Mails, Linkedin, Github, NotebookPen, CalendarPlus } from "lucide-react";

export default function Contact() {
  return (
    <section id="contact" className="page-contact">
      <div className="contact-container">
        <div className="contact-inner">
          <header className="contact-header">
            <h2 className="section-title">Contact Me</h2>
            <p className="lead">
              I'd love to connect! Feel free to reach out using any of the platforms below.
            </p>
          </header>

          <div className="contact-info-grid">
            <div className="contact-card">
              <Mails size={28} className="contact-icon" />
              <h3>Email</h3>
              <p><a href="mailto:christian.lira.gl@gmail.com">christian.lira.gl@gmail.com</a></p>
            </div>

            <div className="contact-card">
              <Linkedin size={28} className="contact-icon" />
              <h3>LinkedIn</h3>
              <p>
                <a href="https://www.linkedin.com/in/christianlg/" target="_blank" rel="noopener noreferrer">
                  linkedin.com/in/christianlg
                </a>
              </p>
            </div>

            <div className="contact-card">
              <Github size={28} className="contact-icon" />
              <h3>GitHub</h3>
              <p>
                <a href="https://github.com/ChristianLG2" target="_blank" rel="noopener noreferrer">
                  github.com/ChristianLG2
                </a>
              </p>
            </div>

            <div className="contact-card">
              <NotebookPen size={28} className="contact-icon" />
              <h3>Personal Blog</h3>
              <p>
                <a href="https://substack.com/@christianlirag" target="_blank" rel="noopener noreferrer">
                  substack.com/@christianlirag
                </a>
              </p>
            </div>
          </div>

          <div className="calendly-card">
            <CalendarPlus size={28} className="contact-icon" />
            <h3 className="contact-title">Meet With Me</h3>
            <p className="contact-text">
              Let’s chat! Whether you’re exploring hiring opportunities, a collaboration,
              or a project you’re passionate about, schedule a 30-minute call.
            </p>
            <iframe
              src="https://calendly.com/christian-lira-gl/30min?hide_event_type_details=1&background_color=1e1e1e&text_color=ffffff"
              width="100%"
              height="520"
              frameBorder="0"
              title="Calendly Scheduler"
              className="calendly-iframe"
              loading="lazy"
            />
          </div>

          <p className="footnote">Hiring, collaborating, or curious about Orpheus, this is the right place to start.</p>
        </div>
      </div>
    </section>
  );
}










